import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Viewpackages = ({ onClose, name }) => {
  const [roolSection, setRoolSection] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getadminpackage`);
      if (Array.isArray(response.data.Rool)) {
        setRoolSection(response.data.Rool);
      } else {
        setRoolSection([]);
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setRoolSection([]);
    }
  };

  useEffect(() => {
    fetchRools();
  }, []);

  useEffect(() => {
    if (roolSection.length > 0) {
      console.log('Name:', name?.website);
      console.log('roolSection:', roolSection);

      // Ensure name.website is a string and trim for comparison
      const nameString = typeof name?.website === 'string' ? name.website.trim().toLowerCase() : '';

      // Filter items based on 'website'
      const foundItem = roolSection.filter(
        (item) => item.website?.trim().toLowerCase() === nameString
      );

      console.log('Found Item:', foundItem);
      setFilterData(foundItem);
    }
  }, [roolSection, name]);
  const handleAddPackage = async (packageData) => {
    console.log("name",name.userId)
    console.log('Selected Package:', packageData);
    const updatedValues = {
      userId:name.userId,
      AddPackage:packageData,
    };
    console.log('Submitted:', updatedValues);
    try {
        const response = await axios.put(
          `http://localhost:4000/update-user/${name.userId}`,
          updatedValues
        );
        console.log("User Updated:", response.data);
        onClose();
      } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        alert(error.response?.data?.error || "Failed to update user.");
      }
  };
  return (
    <div>
      <div
        className="modal fade show"
        aria-modal="true"
        role="dialog"
        style={{ display: 'block' }}
      >
        <div className="modal-lg modal-dialog-centered" style={{margin:"3%"}} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Packages</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">#ID</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Validity</TableCell>
                    <TableCell align="left">imageCount</TableCell>
                    <TableCell align="left">invitationCount</TableCell>
                    <TableCell align="left">maxImageCount</TableCell>
                    <TableCell align="left">VideoCount</TableCell>
                    <TableCell align="left">offerprice</TableCell>
                    <TableCell align="left">price</TableCell>
                    <TableCell align="left">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterData.length > 0 ? (
                    filterData.map((row) => (
                      <TableRow key={row.packageId}>
                        <TableCell align="left">{row.packageId}</TableCell>
                        <TableCell align="left">{row.Name}</TableCell>
                        <TableCell align="left">{row.Validity} {row.Validation}</TableCell>
                        <TableCell align="left">{row.imageCount}</TableCell>
                        <TableCell align="left">{row.invitationCount}</TableCell>
                        <TableCell align="left">{row.maxImageCount}</TableCell>
                        <TableCell align="left">{row.videoCount}</TableCell>
                        <TableCell align="left">{row.offerprice}</TableCell>
                        <TableCell align="left">{row.price}</TableCell>
                        <TableCell align="left">
  <button
    className="btn btn-primary align-middle flex items-center"
    onClick={() => handleAddPackage(row)}
  >
    Add
  </button>
</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No packages found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewpackages;
